import { render, staticRenderFns } from "./VesselList.vue?vue&type=template&id=2eea1d07"
import script from "./VesselList.vue?vue&type=script&lang=js"
export * from "./VesselList.vue?vue&type=script&lang=js"
import style0 from "./VesselList.vue?vue&type=style&index=0&id=2eea1d07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports